import { FormControl, MenuItem, Select } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import i18n from "../i18n";
import {
  SUPPORTED_LANGUAGES,
  LANGUAGE_DISPLAY_NAMES,
  getStoredLanguage,
  setStoredLanguage,
} from "../i18n/locale";

// Mounted once in App.js so it's available on every page. Picking a language updates the stored
// override (read by the axios `language` header on the next request) and i18next's UI language,
// then reloads so every already-fetched menu/cart/order query refetches translated -- same
// "change language -> restart" pattern Kiosk/EPOS use, just a page reload instead of an app restart.
function LanguageSwitcher() {
  const current = getStoredLanguage() || "en";

  const handleChange = (event) => {
    const language = event.target.value;
    setStoredLanguage(language);
    i18n.changeLanguage(language);
    window.location.reload();
  };

  return (
    <FormControl
      size="small"
      sx={{
        position: "fixed",
        top: 12,
        right: 12,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        minWidth: 56,
      }}
    >
      <Select
        value={current}
        onChange={handleChange}
        displayEmpty
        renderValue={() => <LanguageIcon fontSize="small" sx={{ display: "block" }} />}
        sx={{
          bgcolor: "background.paper",
          borderRadius: "50%",
          width: 40,
          height: 40,
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            height: "100%",
          },
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          boxShadow: 1,
        }}
        inputProps={{ "aria-label": "Select language" }}
      >
        <MenuItem value="en">{LANGUAGE_DISPLAY_NAMES.en}</MenuItem>
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem key={language} value={language}>
            {LANGUAGE_DISPLAY_NAMES[language] || language}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher;
